import React, { useCallback, useMemo, useRef } from 'react'
import { useProgramSearch } from 'hooks/useProgramSearch'
import { PaginatedDropdown } from 'components'
import uuid from 'uuid/v4'

const ScholarshipPicker = (
  {
    disableOption,
    searchKey = 'globalSearch',
    searchOnEnter,
    showRightIcon = false,
    ...props
  },
  ref
) => {
  const { data, setFilter, loading } = useProgramSearch()
  const fetchOptions = useCallback(
    ({ term, ...rest }) => setFilter({ [searchKey]: term, ...rest }),
    [setFilter]
  )
  const localRef = useRef()
  const widgetRef = ref || localRef

  const parsedPrograms = useMemo(() => {
    return disableOption
      ? data?.programs?.map((item) => ({
          ...item,
          disabled: item.disabled || disableOption(item),
        }))
      : data?.programs
  }, [data, disableOption])


  const addCustomValue = (value) => {
    const items = [...widgetRef.current.state.selected, value]
    if (props.multiple) {
      widgetRef.current.state.selected = items
      widgetRef.current.state.text = ''
    }
    props.onChange(items, widgetRef)
    widgetRef.current.hideMenu()
  }

  const searchProps = searchOnEnter
    ? {
        onKeyDown({ keyCode, target: { value } }) {
          if (keyCode === 13) {
             // Enter key pressed
            addCustomValue(value)
          }
        },
      }
    : {}

  const handleIconClick = (value) => {
    addCustomValue(value)
    widgetRef.current.hideMenu()
  }

  return (
    <PaginatedDropdown
      isLoading={loading}
      source={parsedPrograms}
      placeholder="Select a scholarship..."
      labelKey="programName"
      selected={props?.selected || props?.value}
      {...searchProps}
      ref={widgetRef}
      positionFixed
      handleIconClick={handleIconClick}
      showRightIcon={showRightIcon}
      {...{ fetchOptions, ...props }}
    />
  )
}

export default React.forwardRef(ScholarshipPicker)
